import { Typography, TypographyProps, styled } from "@mui/material";

const LargeTypography = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: "#070606",
    fontSize: '20px',
    fontWeight: 600
}));

export default LargeTypography